import React from 'react'
// import './InfoRow.css'

function ParameterDetails({data}) {
  return (
  <div className="specGrid">
    <div>
      <div className="specRow">
        <div className="specLabel">Meas.</div>
        <div className='specValue'>{
            data?.length && data?.width && data?.height
                ? `${data.length}${data?.shape?.toLowerCase() === "round" ? "*" : "-"}${data.width}*${data.height}`
                : "-"
            }</div>
      </div>

      <div className="specRow">
        <div className="specLabel">Table %</div>
        <div className='specValue'>{data?.tablePercent}</div>
      </div>

      <div className="specRow">
        <div className="specLabel">Depth %</div>
        <div className='specValue'>{data?.depthPercent}</div>
      </div>

      <div className="specRow">
        <div className="specLabel">Cr. Height %</div>
        <div className='specValue'>{data?.crownHeight}</div>
      </div>
      <div className="specRow">
        <div className="specLabel">Cr. Angle °</div>
        <div className='specValue'>{data?.crownAngle}</div>
      </div>
      <div className="specRow">
        <div className="specLabel">Pav. Height %</div>
        <div className='specValue'>{data?.pavilionHeight}</div>
      </div>
      <div className="specRow">
        <div className="specLabel">Pav. Angle °</div>
        <div className='specValue'>{data?.pavilionAngle}</div>
      </div>
    </div>

    <div>
        {data?.ratio && data?.ratio !== "-" ? 
      <div className="specRow">
        <div className="specLabel">Ratio</div>
        <div className='specValue'>{data?.ratio}</div>
      </div>
      :null}
      <div className="specRow">
        <div className="specLabel">Girdle</div>
        <div className='specValue'>{data?.girdle}</div>
      </div>
    {data?.girdleCondition ? 
      <div className="specRow">
        <div className="specLabel">Girdle Condition</div>
        <div className='specValue'>{data?.girdleCondition}</div>
      </div>
      :null}
       {data?.girdle_thin ? 
      <div className="specRow">
        <div className="specLabel">Girdle Thin</div>
        <div className='specValue'>{data?.girdle_thin}</div>
      </div>
      :null}
      {data?.girdle_thick ? 
      <div className="specRow">
        <div className="specLabel">Girdle Thick</div>
        <div className='specValue'>{data?.girdle_thick}</div>
      </div>
      :null}
      {data?.culet_condition ? 
      <div className="specRow">
        <div className="specLabel">Culet</div>
        <div className='specValue'>{data?.culet_condition}</div>
      </div>
      :null}
    </div>
  </div>
  )
}

export default ParameterDetails